export default function isCheckboxItem(element) {
  var role = element.getAttribute('role');
  return role === 'radio' || role === 'menuitemradio';
}